import { createFileRoute } from "@tanstack/react-router";
import { AgentsList, type AgentsSearch } from "../../features/agents/agents-list";

const TABS = ["runs", "groups", "agents"] as const;
const VIEWS = ["parallel", "longhorizon"] as const;

export const Route = createFileRoute("/_authed/$org/$project/agents/")({
  validateSearch: (s: Record<string, unknown>): AgentsSearch => ({
    ...(VIEWS.includes(s.view as never) ? { view: s.view as AgentsSearch["view"] } : {}),
    ...(TABS.includes(s.tab as never) ? { tab: s.tab as AgentsSearch["tab"] } : {}),
    ...(s.create === "run" || s.create === "agent" ? { create: s.create } : {}),
    ...(typeof s.model === "string" && s.model ? { model: s.model } : {}),
    ...(typeof s.q === "string" && s.q ? { q: s.q } : {}),
  }),
  component: AgentsPage,
});

function AgentsPage() {
  const { org, project } = Route.useParams();
  return <AgentsList scope={{ org, project }} search={Route.useSearch()} />;
}
